export const Nbsp = () => '\u00A0';
